module.exports = __webpack_public_path__ + "img/CDM.3de8bc0e.jpg";